// oxlint-disable-next-line no-restricted-imports
import { useCachedBinaryUrl } from '@medplum/react-hooks'
import { isExternalUrl } from '#src/components/attachments/attachment-utils.ts'

/*
 * Returns a stable URL for attachment content, suitable for use in refs, state,
 * or equality comparisons across renders. Without this, Medplum Binary URLs
 * include signed parameters that change on every fetch — causing components that
 * compare URLs (e.g. expanded attachment views) to reset unexpectedly.
 *
 * Internal Binary URLs are routed through `useCachedBinaryUrl` to strip the
 * volatile params; external URLs (e.g. Health Gorilla lab results) are passed
 * through as-is, since `useCachedBinaryUrl` would fail on non-Medplum URLs.
 */
export function useStableAttachmentUrl(url: string): string | undefined
export function useStableAttachmentUrl(url: undefined): undefined
export function useStableAttachmentUrl(
  url: string | undefined
): string | undefined
export function useStableAttachmentUrl(
  url: string | undefined
): string | undefined {
  const isExternal = isExternalUrl(url)
  const cachedUrl = useCachedBinaryUrl(isExternal ? undefined : url)

  if (url === undefined) {
    return undefined
  }

  if (url === '') {
    return ''
  }

  if (isExternal) {
    return url
  }

  return cachedUrl
}
